"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMethodOption = void 0;
exports.decodeMethodOption = [
    {
        id: 0,
        name: 'Any',
    },
    {
        id: 'vin',
        name: 'VIN',
    },
    {
        id: 'fuzzy',
        name: 'Fuzzy',
    },
    {
        id: 'reverse',
        name: 'Reverse',
    },
    {
        id: 'reverseFuzzy',
        name: 'Reverse Fuzzy',
    },
    {
        id: 'none',
        name: 'None',
    },
];
